// Public ingestion addresses, not account or source-map upload credentials.
export const browserDSN='https://cc3f27c332deba5bf889f1247cca0e9e@o4507787263475712.ingest.us.sentry.io/4512363897421824';
export const workerDSN='https://db9c792f3b39cb4dc98f2515d8e920d0@o4507787263475712.ingest.us.sentry.io/4512363900436480';
export const ingestOrigin='https://o4507787263475712.ingest.us.sentry.io';
export const operations=new Set(['engagement-save','acknowledgement','preferences-read','preferences-write','admin-delivery','admin-jobs']);
export function environmentForHost(hostname){
 if(['wefundgood.org','www.wefundgood.org'].includes(hostname))return 'production';
 if(hostname==='wfg-website.matt-464.workers.dev')return 'review';
 return null;
}
function isPrivatePath(pathname){
 try{return decodeURIComponent(pathname).startsWith('/research/');}catch{return true;}
}
function cleanURL(value){
 try{
  const url=new URL(value);
  if(!environmentForHost(url.hostname))return undefined;
  if(isPrivatePath(url.pathname))return undefined;
  return url.origin+url.pathname;
 }catch{return undefined;}
}
function cleanFrame(frame){
 const result={};
 if(typeof frame.filename==='string'){
  // Remove query strings, fragments, absolute build-machine paths and source snippets.
  const file=frame.filename.split(/[?#]/)[0];
  result.filename=cleanURL(file)||file.replaceAll('\\','/').split('/').at(-1);
 }
 if(typeof frame.function==='string'&&/^[\w.$ <>:[\]-]{1,120}$/.test(frame.function))result.function=frame.function;
 for(const key of ['lineno','colno'])if(Number.isInteger(frame[key]))result[key]=frame[key];
 if(typeof frame.in_app==='boolean')result.in_app=frame.in_app;
 return result;
}
const safeMessage=value=>typeof value==='string'&&(
 /^WFG Sentry verification (browser|worker)$/.test(value)||
 [...operations].some(operation=>value===`WFG operation failed: ${operation}`)
)?value:'Error details withheld to protect submitted data.';

// Allowlist the event fields we need. Never forward arbitrary request payloads,
// breadcrumbs, custom contexts, logs, user identifiers or thrown free text.
export function sanitiseEvent(event){
 if(event.type)return null; // Error monitoring only, no transactions or other signals.
 if(event.request?.url){
  try{if(isPrivatePath(new URL(event.request.url).pathname))return null;}catch{}
 }
 const clean={};
 for(const key of ['event_id','timestamp','platform','release','environment','level','sdk'])if(event[key]!==undefined)clean[key]=event[key];
 if(event.request?.url){const url=cleanURL(event.request.url);if(url)clean.request={url};}
 if(event.message)clean.message=safeMessage(event.message);
 if(event.exception?.values)clean.exception={values:event.exception.values.map(value=>({
  type:['Error','TypeError','ReferenceError','SyntaxError','RangeError','URIError','EvalError','AggregateError'].includes(value.type)?value.type:'Error',
  value:safeMessage(value.value),
  ...(value.stacktrace?.frames?{stacktrace:{frames:value.stacktrace.frames.map(cleanFrame)}}:{}),
  ...(value.mechanism?{mechanism:{type:'generic',handled:value.mechanism.handled!==false}}:{})
 }))};
 if(event.tags?.operation&&operations.has(event.tags.operation))clean.tags={operation:event.tags.operation};
 return clean;
}
export const privacyOptions={
 sendDefaultPii:false, maxBreadcrumbs:0, sendClientReports:false,
 tracesSampleRate:0, enableLogs:false, enableMetrics:false,
 traceLifecycle:'static',tracePropagationTargets:[],
 beforeSend:sanitiseEvent, beforeSendTransaction:()=>null,
};
